import React, { Component } from 'react';
import { Form, Formik } from 'formik'
import onboarding from 'assets/images/onboarding.png'
import RouteConst from '../../../../constants/RouteConst'
import * as FormConst from '../../../../constants/FormConst'
import Button from '../../../atoms/Button/Button'
import FormModal from '../../../organisms/FormModal/FormModal'
import RatesConfigurationService from '../../../../services/RatesConfigurationService'
import RatePlanConfigurationService from '../../../../services/RatePlanConfigurationService'
import { isArrayNotEmpty } from '../../../../utilities/JSUtil'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import SelectInput  from '../../../atoms/form/SelectInput/SelectInput'
import { Col, Row } from 'react-bootstrap'
import * as Yup from 'yup';
import * as BrandConst from '../../../../constants/BrandConst'
import './RatesConfiguration.scss';

export class RatesConfiguration extends Component {

    constructor(props) {
        super(props)

        this.state = {
            rates: [],
            ratePlans: [],
            isAdd: false,
            isEdit: false,
            isDelete: false,
            isLoading: true,
            showErrorModal: false,
            errorMessage: undefined,
            currentRate: undefined,
            currentRateIndex: undefined,
            isRateTypeSelected: false,
        }
    }

    // To submit the add and edit forms from the form modal buttons which is outside of formik
    submitForm = null;

    handleSubmitForm = (data) => {
        if (this.submitForm) {
            this.submitForm(data);
        }
    }

    bindSubmitForm = (submitForm) => {
        this.submitForm = submitForm;
    }

    validationSchema = Yup.object().shape({
        code: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        rateType: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        adjustmentAmount: Yup.number()
            .min(0, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .max(FormConst.MAX_LENGTH_RATES_VALUES, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .test('Adjustment Amount validation', function (val) {
                if (this.parent.rateType === FormConst.RATE_TYPE_PERCENT && (val === undefined || val === '')) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED})
                }
                return true
            }),
        adrAmount1: Yup.number()
            .min(0, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .max(FormConst.MAX_LENGTH_RATES_VALUES, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .test('Adr Amount 1 validation', function (val) {
                if ((!!this.parent.onePersonAmount || !!this.parent.twoPersonAmount) && val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_AND_PERSON_AMOUNT_NOT_ALLOWED})
                }
                if (this.parent.rateType === FormConst.RATE_TYPE_FLAT && !this.parent.onePersonAmount && !this.parent.twoPersonAmount 
                    && !val) {

                    if (!this.parent.adrAmount2 && !this.parent.adrAmount3) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_OR_PERSON_AMOUNT_REQUIRED})
                    }
                    
                    if (this.parent.adrAmount2 || this.parent.adrAmount3) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED})
                    }
                }
                return true
            }
        ),
        adrAmount2: Yup.number()
            .min(0, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .max(FormConst.MAX_LENGTH_RATES_VALUES, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .test('Adr Amount 2 validation', function (val) {
                if ((!!this.parent.onePersonAmount || !!this.parent.twoPersonAmount) && val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_AND_PERSON_AMOUNT_NOT_ALLOWED})
                }
                if (this.parent.rateType === FormConst.RATE_TYPE_FLAT && !this.parent.onePersonAmount && !this.parent.twoPersonAmount 
                    && !val) {

                    if (!this.parent.adrAmount1 && !this.parent.adrAmount3) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_OR_PERSON_AMOUNT_REQUIRED})
                    }
                    
                    if (this.parent.adrAmount1 || this.parent.adrAmount3) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED})
                    }
                }
                return true
            }
        ),
        adrAmount3: Yup.number()
            .min(0, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .max(FormConst.MAX_LENGTH_RATES_VALUES, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .test('Adr Amount 3 validation', function (val) {
                if ((!!this.parent.onePersonAmount || !!this.parent.twoPersonAmount) && val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_AND_PERSON_AMOUNT_NOT_ALLOWED})
                }
                if (this.parent.rateType === FormConst.RATE_TYPE_FLAT && !this.parent.onePersonAmount && !this.parent.twoPersonAmount 
                    && !val) {

                    if (!this.parent.adrAmount1 && !this.parent.adrAmount2) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_OR_PERSON_AMOUNT_REQUIRED})
                    }
                    
                    if (this.parent.adrAmount1 || this.parent.adrAmount2) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED})
                    }
                }
                return true
            }
        ),
        onePersonAmount: Yup.number()
            .min(0, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .max(FormConst.MAX_LENGTH_RATES_VALUES, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .test('One Person Amount validation', function (val) {
                if ((!!this.parent.adrAmount1 || !!this.parent.adrAmount2 || !!this.parent.adrAmount3) && val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_AND_PERSON_AMOUNT_NOT_ALLOWED})
                }
                if (this.parent.rateType === FormConst.RATE_TYPE_FLAT && !this.parent.adrAmount1 && !this.parent.adrAmount2 
                    && !this.parent.adrAmount3 && !val) {

                    if (!this.parent.twoPersonAmount) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_OR_PERSON_AMOUNT_REQUIRED})
                    }
                    
                    if (this.parent.twoPersonAmount) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED})
                    }
                }
                return true
            }
        ),
        twoPersonAmount: Yup.number()
            .min(0, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .max(FormConst.MAX_LENGTH_RATES_VALUES, FormConst.VALIDATION_ERROR_RATES_VALUES_SIZE)
            .test('Two Person Amount validation', function (val) {
                if ((!!this.parent.adrAmount1 || !!this.parent.adrAmount2 || !!this.parent.adrAmount3) && val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_AND_PERSON_AMOUNT_NOT_ALLOWED})
                }
                if (this.parent.rateType === FormConst.RATE_TYPE_FLAT && !this.parent.adrAmount1 && !this.parent.adrAmount2 
                    && !this.parent.adrAmount3 && !val) {

                    if (!this.parent.onePersonAmount) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_ADR_OR_PERSON_AMOUNT_REQUIRED})
                    }
                    
                    if (this.parent.onePersonAmount) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED})
                    }
                }
                return true
            }
        ),
    })

    async componentDidMount() {
        await RatesConfigurationService.getConfigurableRates()
            .then((ratesResponse) => {

                RatePlanConfigurationService.getConfigurableRatePlans()
                    .then((ratePlanResponse) => {
                        const ratePlans = ratePlanResponse.map((entry) => {
                            return { label: entry.code, value: entry.code }
                        })

                        this.setState({
                            rates: ratesResponse,
                            ratePlans: ratePlans,
                            isLoading: false
                        })
                    })
                    .catch((error) => {
                        this.setState({
                            rates: ratesResponse,
                            showErrorModal: true,
                            errorMessage: 'Error while fetching rate plan codes.',
                            isLoading: false
                        })
                    })
            })
            .catch((error) => {
                this.setState({
                    isLoading: false, 
                    showErrorModal: true,
                    errorMessage: 'Error while fetching rates.'
                })
            })
    }

    prepareData = (data) => {
        if (data.rateType === FormConst.RATE_TYPE_FLAT) {
            data.adjustmentType = undefined
            data.adjustmentAmount = undefined
        } else {
            data.onePersonAmount = undefined
            data.twoPersonAmount = undefined
            data.adrAmount1 = undefined
            data.adrAmount2 = undefined
            data.adrAmount3 = undefined
        }
   }

    doAdd = (data) => {
        this.setState({ isAdd: false, isLoading: true, isRateTypeSelected: false })
        this.prepareData(data)

        RatesConfigurationService.addConfigurableRates(data)
            .then(() => {
                let rates = [...this.state.rates]
                rates.push(data)
                this.setState({
                    rates: rates,
                    isLoading: false
                });
            }).catch((error) => {
                let msg = 'Error while adding rate.'
                if (error.messages[0].code === 'DEFAULT_RATES_ALREADY_EXISTS') {
                    msg = 'Error while adding rate. A rate with the same code, brand, and region combination already exists.'
                }
                this.setState({
                    showErrorModal: true,
                    errorMessage: msg,
                    isLoading: false
                })
            })
    }

    doUpdate = (data) => {
        this.setState({ isEdit: false, currentRate: undefined, isLoading: true, isRateTypeSelected: false })
        this.prepareData(data)

        RatesConfigurationService.updateConfigurableRates(data)
            .then(() => {
                let rates = [...this.state.rates]
                rates[this.state.currentRateIndex] = data
                this.setState({
                    rates: rates,
                    currentRateIndex: undefined,
                    isLoading: false
                });
            }).catch(() => {
                this.setState({
                    showErrorModal: true,
                    errorMessage: 'Error while updating rate.',
                    currentRateIndex: undefined,
                    isLoading: false
                })
            })
    }

    doDelete = () => {
        this.setState({ isDelete: false, isLoading: true })
        const code = this.state.rates[this.state.currentRateIndex].code
        const brand = this.state.rates[this.state.currentRateIndex].brand
        const region = this.state.rates[this.state.currentRateIndex].region

        RatesConfigurationService.deleteConfigurableRates({code: code, brand: brand, region: region})
            .then(() => {
                let rates = [...this.state.rates]
                rates.splice(this.state.currentRateIndex, 1);
                this.setState({
                    rates: rates,
                    currentRateIndex: undefined,
                    isLoading: false
                });
            }).catch(() => {
                this.setState({
                    showErrorModal: true,
                    errorMessage: 'Error while deleting rate.',
                    currentRateIndex: undefined,
                    isLoading: false
                })
            })
    }

    redirectToConfigure = () => {
        this.props.history.push(RouteConst.ROUTE_LAUNCH_CONFIGURE_PAGE)
    }

    render() {
        return (
            <div className='rates-configuration-page'>
                <img id='page-logo' src={onboarding} className='onboarding-img' />
                
                <div className='rates'>
                    <Button 
                        id='configure-page-button' 
                        name='Go to configuration page' 
                        className='configure-button' 
                        onClick={this.redirectToConfigure} />

                    <p id='rates-page-info' className='rates-header'>{FormConst.MODAL_RATES_TITLE}</p>

                    <div className='rates-buttons'>
                        <Button 
                            id='rates-add-button' 
                            name={'(+) Add Rate'} 
                            className='add-button' 
                            onClick={() => this.setState({ isAdd: true })} />
                    </div>

                    <table id='rates-table' className='table table-striped rates-table'>
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Rate Type</th>
                                <th>One Person Amount</th>
                                <th>Two Person Amount</th>
                                <th>Adjustment Type</th>
                                <th>Adjustment Amount</th>
                                <th>Adr Amount 1</th>
                                <th>Adr Amount 2</th>
                                <th>Adr Amount 3</th>
                                <th>Brand</th>
                                <th>Region</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                isArrayNotEmpty(this.state.rates)
                                    ? (
                                        this.state.rates.map((rate, index) =>
                                            <tr key={index}>
                                                <td>{rate.code}</td>
                                                <td>{rate.rateType}</td>
                                                <td>{rate.onePersonAmount}</td>
                                                <td>{rate.twoPersonAmount}</td>
                                                <td>{rate.adjustmentType}</td>
                                                <td>{rate.adjustmentAmount}</td>
                                                <td>{rate.adrAmount1}</td>
                                                <td>{rate.adrAmount2}</td>
                                                <td>{rate.adrAmount3}</td>
                                                <td>{rate.brand}</td>
                                                <td>{rate.region}</td>
                                                <td><Button name={<FaEdit />} role='link' className='icon-link' 
                                                        onClick={() => this.setState({ isEdit: true, currentRate: rate, currentRateIndex: index, isRateTypeSelected: true})}/>
                                                </td>
                                                <td><Button name={<FaTrashAlt />} role='link' className='icon-link' 
                                                        onClick={() => this.setState({ isDelete: true, currentRateIndex: index })}/>
                                                </td>
                                            </tr>
                                        )
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={13} className='text-center'>No rates found.</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>

                    <Button 
                        id='configure-page-button' 
                        name='Go to configuration page' 
                        className='configure-button' 
                        onClick={this.redirectToConfigure} />

                    <FormModal
                        id='rates-add-edit-modal'
                        title={FormConst.MODAL_RATES_DETAILS}
                        body={
                            <div id='rates-add-update'>
                                <Formik
                                    initialValues={{
                                        code: this.state.currentRate ? this.state.currentRate.code : '',
                                        rateType: this.state.currentRate ? this.state.currentRate.rateType : '',
                                        onePersonAmount: this.state.currentRate ? this.state.currentRate.onePersonAmount : undefined,
                                        twoPersonAmount: this.state.currentRate ? this.state.currentRate.twoPersonAmount : undefined,
                                        adjustmentType: FormConst.ADJUSTMENT_TYPE_OFF,
                                        adjustmentAmount: this.state.currentRate ? this.state.currentRate.adjustmentAmount : undefined,
                                        adrAmount1: this.state.currentRate ? this.state.currentRate.adrAmount1 : undefined,
                                        adrAmount2: this.state.currentRate ? this.state.currentRate.adrAmount2 : undefined,
                                        adrAmount3: this.state.currentRate ? this.state.currentRate.adrAmount3 : undefined,
                                        brand: this.state.currentRate ? this.state.currentRate.brand : undefined,
                                        region: this.state.currentRate ? this.state.currentRate.region : undefined
                                    }}
                                    validationSchema={this.validationSchema}
                                    onSubmit={(data, { setSubmitting }) => {
                                        setSubmitting(true)
                                        this.state.isEdit ? this.doUpdate(data) : this.doAdd(data)
                                        setSubmitting(false)
                                    }}>
                                    {(formikProps) => {
                                        const { values, handleChange } = formikProps;
                                        this.bindSubmitForm(formikProps.submitForm);
                                        return (
                                            <Form id='rates-update-form'>
                                                <Row>
                                                    <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                                        {
                                                            isArrayNotEmpty(this.state.ratePlans)
                                                            ? (
                                                                <>
                                                                    <SelectInput name='code' id='code' key='code' label='Code' options={this.state.ratePlans} onChange={handleChange} isrequired='true' disabled={this.state.isEdit} />
                                                                    <SelectInput name='brand' id='brand' key='brand' label='Brand' options={BrandConst.BRAND_CODES_OPTIONS} onChange={handleChange} disabled={this.state.isEdit}/>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <TextInput id='code' name='code' type='text' label='Code' isrequired='true' onChange={handleChange}/>
                                                                    <SelectInput name='brand' id='brand' key='brand' label='Brand' options={BrandConst.BRAND_CODES_OPTIONS} onChange={handleChange} disabled={this.state.isEdit}/>
                                                                </>
                                                            )
                                                        }
                                                    </Col>
                                                    <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                                        <SelectInput name='rateType' id='rateType' key='rateType' label='Rate Type' options={FormConst.RATE_TYPES_OPTIONS_SAME_LABEL_AND_VALUE} isrequired='true'
                                                            onChange={(e) => { handleChange(e); this.setState({isRateTypeSelected: true})}} />
                                                        <SelectInput id='region' name='region' key='region' label='Region' options={FormConst.REGION_OPTIONS} onChange={handleChange} disabled={this.state.isEdit}/>
                                                    </Col>
                                                    {
                                                        this.state.isRateTypeSelected &&
                                                        <>
                                                            {
                                                                values.rateType === FormConst.RATE_TYPE_FLAT 
                                                                ? (
                                                                    <>
                                                                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>                                                                   
                                                                            <TextInput id='onePersonAmount' name='onePersonAmount' type='number' label='One Person Amount' onChange={handleChange} />
                                                                            <TextInput id='adrAmount1' name='adrAmount1' type='number' label='Adr Amount 1' onChange={handleChange} />
                                                                        </Col>
                                                                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                            <TextInput id='twoPersonAmount' name='twoPersonAmount' type='number' label='Two Person Amount' onChange={handleChange} 
                                                                                value={values.twoPersonAmount === undefined ? '' : values.twoPersonAmount} />
                                                                            <TextInput id='adrAmount2' name='adrAmount2' type='number' label='Adr Amount 2' onChange={handleChange} />
                                                                        </Col>
                                                                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                            <TextInput id='adrAmount3' name='adrAmount3' type='number' label='Adr Amount 3' onChange={handleChange} />
                                                                        </Col>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>                                                                   
                                                                            <TextInput id='adjustmentType' name='adjustmentType' type='text' label='Adjustment Type' value={values.adjustmentType} disabled={true}/>
                                                                        </Col>
                                                                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                            <TextInput id='adjustmentAmount' name='adjustmentAmount' type='number' label='Adjustment Amount' onChange={handleChange} 
                                                                                value={values.adjustmentAmount === undefined ? '' : values.adjustmentAmount} />
                                                                        </Col>
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    }
                                                </Row>
                                            </Form>
                                        )
                                    }}
                                </Formik>
                            </div>
                        }
                        show={this.state.isEdit || this.state.isAdd}
                        size='xl'
                        proceed={this.handleSubmitForm}
                        proceedName={FormConst.ACTION_SAVE}
                        cancel={() => this.setState({ isAdd: false, isEdit: false, currentRate: undefined, currentRateIndex: undefined, isRateTypeSelected: false }) }
                        hideLogo/>

                    <FormModal
                        id='rates-delete-confirmation-modal'
                        title={FormConst.MODAL_RATES_TITLE}
                        body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                        show={this.state.isDelete}
                        proceed={() => this.doDelete()} 
                        cancel={() => this.setState({ isDelete: false, currentRate: undefined, currentRateIndex: undefined }) }/>

                    <FormModal
                        id='rates-page-loading-modal'
                        title={FormConst.MODAL_READ_ACTION_TITLE}
                        body={<h6>{FormConst.MODAL_READ_ACTION_TEXT}</h6>}
                        show={this.state.isLoading}
                        isLoadingIndicator />

                    <FormModal
                        id='rates-page-error-modal'
                        title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                        body={<h5>{this.state.errorMessage}</h5>}
                        show={this.state.showErrorModal}
                        cancel={() => { this.setState({ showErrorModal: false, errorMessage: undefined }) }}
                        isError />
                </div>
            </div>
        )
    }
}

export default RatesConfiguration